module.exports = "\r\n\r\n#level2 a{\r\n    display: inline-block;\r\n    text-align: center;\r\n    margin-right:10px;  \r\n    color:#444;\r\n    text-decoration: none;\r\n    -webkit-transition: .5s;\r\n    transition: .5s;\r\n    font-size: 14px;\r\n}\r\n\r\n#level2 a:hover{\r\n    background: #ccc;\r\n}\r\n\r\n#level2 span{\r\n    display: block;\r\n    padding: 3px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/menu/menu.component.css
// module id = ./src/app/common/menu/menu.component.css
// module chunks = main